export class GUIDHelper {
    public static create() {
        let guid: string = null;

        try {
            guid = crypto.randomUUID();
        } catch {
            const uuidv4 = () => {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
                .replace(/[xy]/g, function (c) {
                    const r = Math.random() * 16 | 0, 
                        v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            }

            guid = uuidv4();
        }

        return guid;
    }
}